export default "__VITE_ASSET__BXSo0irI__"